import React, { useState } from "react";
import "../css/ContactScreen.css";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import emailjs from "emailjs-com";
import fire from "../config/fire";
import { getDatabase, ref, set, onValue } from "firebase/database";
import LoaderComponent from "../component/LoaderComponent";
import { sendEmail } from "../component/emailService";

emailjs.init("C48u70GDz5s6uyPcS");
const ContactUsFormComp = ({
	productId = null,
	productTitle = "",
	setMessageSendFlag = () => {},
}) => {
	const [formData, setFormData] = useState({
		companyName: "",
		name: "",
		email: "",
		phone: "",
		country: "",
		quantity: "",
		isInterested: "", // YES / NO dropdown
		message: "",
	});
	const [loader, setLoader] = useState(false);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoader(true);
		const id = Date.now().toString();
		const db = getDatabase();
		sendEmail({
			from_name: formData.name,
			from_email: formData.email,
			companyName: formData.companyName,
			country: formData.country,
			quantity: formData.quantity,
			phone: formData.phone,
			isInterested: formData.isInterested, // ✅ added
			message: formData.message,
			id,
		}).then(
			async () => {
				await set(ref(db, `customerquery/${id}`), {
					...formData,
					productId,
					productTitle,
				});
				toast.success("Message sent successfully!");
				setFormData({
					companyName: "",
					name: "",
					email: "",
					phone: "",
					country: "",
					quantity: "",
					isInterested: "",
					message: "",
				});
				setLoader(false);
				setTimeout(() => {
					setMessageSendFlag(true); // triggers modal close
				}, 1400);
			},
			(error) => {
				toast.warn("Failed to send message. Try again!");
				console.error(error);
				setLoader(false);
			},
		);
	};

	return (
		<>
			{loader && <LoaderComponent />}
			<ToastContainer />
			<form onSubmit={handleSubmit}>
				<div className="input-group">
					<input
						type="text"
						name="companyName"
						placeholder="Company name"
						value={formData.companyName}
						onChange={handleChange}
						required
					/>
				</div>
				<div className="input-group">
					<input
						type="text"
						name="name"
						placeholder="Your name"
						value={formData.name}
						onChange={handleChange}
						required
					/>
				</div>

				<div className="input-group">
					<input
						type="email"
						name="email"
						placeholder="Email"
						value={formData.email}
						onChange={handleChange}
						required
					/>
				</div>

				<div className="input-group">
					<input
						type="tel"
						name="phone"
						placeholder="Mobile number"
						value={formData.phone}
						onChange={handleChange}
						pattern="^\+?[0-9\s]{7,15}$"
						title="Please enter a 10-digit mobile number"
					/>
				</div>

				<div className="input-group">
					<input
						type="text"
						name="country"
						placeholder="Country name"
						value={formData.country}
						onChange={handleChange}
						required
					/>
				</div>

				<div className="input-group">
					<input
						type="text"
						name="quantity"
						placeholder="Quantity"
						value={formData.quantity}
						onChange={handleChange}
					/>
				</div>

				<div className="input-group p-3">
					<label className="customization mr-4">Customization</label>
					<select
						name="isInterested"
						value={formData.isInterested}
						onChange={handleChange}
					>
						<option value="">Select an option</option>
						<option value="YES">YES</option>
						<option value="NO">NO</option>
					</select>
				</div>

				<div className="input-group">
					<textarea
						name="message"
						placeholder="Your Message"
						value={formData.message}
						onChange={handleChange}
						required
					></textarea>
				</div>

				<button type="submit" className="submit-btn mt-5">
					Send Message
				</button>
			</form>
		</>
	);
};

export default ContactUsFormComp;
